import {Logger} from '../HelperFunctions';

const storeData = async (key: string, value: string) => {
  const jsonValue = JSON.stringify(value);
  try {
    window.sessionStorage.setItem(key, jsonValue);
  } catch (error) {
    Logger('SecureStore storeData  error =======');
  }
};

const storeObjectData = async (key: string, value: string) => {
  try {
    const jsonValue = JSON.stringify(value);
    window.sessionStorage.setItem(key, jsonValue);
  } catch (e) {
    Logger('SecureStore storeObjectData  error =======');
  }
};

const getData = async (key: string) => {
  try {
    const value = window.sessionStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (e) {
    Logger('SecureStore getData  error =======' + e);
  }
};

const getObjectData = async (key: string) => {
  try {
    const jsonValue = window.sessionStorage.getItem(key);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (e) {
    Logger('SecureStore getObjectData  error =======');
  }
};

const clearData = async (key: string) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (e) {
    Logger('SecureStore clearData  error =======');
  }
};

const clearAll = async () => {
  Logger('SecureStore clearAll =======');
  try {
    window.sessionStorage.clear();
  } catch (e) {
    Logger('SecureStore clearAll  error =======');
  }
};

export default {
  storeData,
  storeObjectData,
  clearData,
  clearAll,
  getObjectData,
  getData,
};
